export interface registerItem {
  displayName: string;
  dependance?: itemDependance;
  errorMsg: string;
  errorRegex?: RegExp;
  hasToBeSended: boolean;
  isDependant: boolean;
  isPasswordConfirmation?: boolean;
  isRequired: boolean;
  isSelect: boolean;
  isValid: boolean;
  itemName: string;
  type?: TextFieldTypes;
  values?: itemSelect[];
  value: string;
}
type TextFieldTypes =
  | "date"
  | "email"
  | "number"
  | "password"
  | "search"
  | "tel"
  | "text"
  | "url"
  | "time"
  | "week"
  | "month"
  | "datetime-local";

// if type => select => values.length > 0 if not refer to dependant
//if isPasswordConfirmation, check between password & its confirmation
// if isDependant => isRequired only if itemDependance.values is ok

interface itemDependance {
  registerItemName: string;
  value: string[];
}

export interface itemSelect {
  value: string;
  label: string;
}

const regsiterItems: registerItem[] = [
  {
    displayName: "Nom",
    itemName: "lastname",
    isRequired: true,
    errorMsg: "Veuillez entrez un nom correct",
    errorRegex:
      /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/iu,
    hasToBeSended: true,
    isDependant: false,
    isSelect: false,
    type: "text",
    isValid: false,
    value: "",
  },
  {
    displayName: "Prénom",
    itemName: "firstname",
    isRequired: true,
    errorMsg: "Veuillez entrez un prénom correct",
    errorRegex:
      /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/iu,
    hasToBeSended: true,
    isDependant: false,
    isSelect: false,
    type: "text",
    isValid: false,
    value: "",
  },
  {
    displayName: "Email",
    itemName: "email",
    isRequired: true,
    errorMsg: "Veuillez entrez un email correct",
    errorRegex:
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    hasToBeSended: true,
    isSelect: false,
    isDependant: false,
    type: "text",
    isValid: false,
    value: "",
  },
  {
    displayName: "Téléphone",
    itemName: "phoneNumber",
    isRequired: true,
    errorMsg: "Veuillez entrez un numéro d'au moins 10 chiffres",
    errorRegex: /^.{10,}$/,
    hasToBeSended: true,
    isSelect: false,
    isDependant: false,
    type: "tel",
    isValid: false,
    value: "",
  },
  {
    displayName: "Mot de passe",
    itemName: "password",
    isRequired: true,
    errorMsg:
      "Veuillez entrez un mot de passe de 8 caractères avec une majuscule, une minuscule et un chiffre au moins !",
    errorRegex: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,32}$/,
    hasToBeSended: true,
    isSelect: false,
    isDependant: false,
    type: "password",
    isValid: false,
    value: "",
  },
  {
    displayName: "Confirmez votre mot de passe",
    itemName: "passwordConfirmation",
    errorMsg: "Vos mots de passe sont différents",
    hasToBeSended: false,
    isSelect: false,
    isDependant: false,
    isRequired: true,
    isValid: false,
    type: "password",
    isPasswordConfirmation: true,
    value: "",
  },
  {
    displayName: "Statut",
    itemName: "statut",
    errorMsg: "Veuillez choisir un statut",
    hasToBeSended: true,
    isRequired: true,
    isSelect: true,
    isValid: false,
    isDependant: false,
    values: [
      { label: "Elève", value: "eleve" },
      { label: "Enseignant", value: "enseignant" },
      { label: "Autre", value: "autre" },
    ],
    value: "",
  },
  {
    displayName: "Etablissement",
    errorMsg: "Veuillez choisir un établissement",
    hasToBeSended: true,
    isDependant: true,
    isRequired: false,
    isSelect: true,
    isValid: false,
    itemName: "etablissement",
    dependance: { registerItemName: "statut", value: ["eleve", "enseignant"] },
    value: "",
  },
  {
    displayName: "Nom du formateur",
    errorMsg: "Veuillez choisir un formateur",
    hasToBeSended: true,
    isDependant: true,
    isSelect: true,
    isRequired: false,
    isValid: false,
    itemName: "prof",
    dependance: { registerItemName: "statut", value: ["eleve"] },
    value: "",
  },
  {
    displayName: "Classe",
    errorMsg: "Veuillez mettre une classe valide",
    hasToBeSended: true,
    isDependant: true,
    isRequired: false,
    isSelect: false,
    isValid: false,
    itemName: "classe",
    type: "text",
    dependance: { registerItemName: "statut", value: ["eleve"] },
    value: "",
  },
];

export default regsiterItems;
